module.exports = __webpack_public_path__ + "static/img/BN.e9cdde8d.png";